'use client';

import { jsx } from "react/jsx-runtime";
import { Text } from "../../atoms/Text/Text.js";
import { FakeOption } from "./Select.FakeOption.js";
import { optionContent } from "./Select.css.js";
function Empty({
  emptyLabel,
  isLoading,
  noOptionsProvided
}) {
  return !isLoading && noOptionsProvided && /* @__PURE__ */ jsx(FakeOption, { children: /* @__PURE__ */ jsx("div", { className: optionContent, children: /* @__PURE__ */ jsx(Text, { color: "onLight.text.tertiary", variant: "body.base", children: emptyLabel }) }) });
}
export {
  Empty
};
